document.querySelectorAll('.js-editorial-text').forEach((editorial) => {
  const toggle = editorial.querySelector('.js-editorial-text-toggle')
  const label = editorial.querySelector('.js-editorial-text-toggle-label')

  if (!toggle || !label) {
    return
  }

  const setExpanded = (isExpanded) => {
    editorial.classList.toggle('editorial-text--expanded', isExpanded)
    toggle.setAttribute('aria-expanded', isExpanded.toString())
    label.textContent = isExpanded
      ? toggle.dataset.closeLabel
      : toggle.dataset.openLabel
  }

  editorial.classList.add('editorial-text--enhanced')
  setExpanded(false)

  toggle.addEventListener('click', () => {
    setExpanded(toggle.getAttribute('aria-expanded') !== 'true')
  })
})
